module.exports = __webpack_public_path__ + "static/media/panoramic.1ddac8fa.svg";